module.exports = __webpack_public_path__ + "static/media/background.4f082761.jpg";